import { render, staticRenderFns } from "./modalCaja.vue?vue&type=template&id=4c09ac63&scoped=true"
import script from "./modalCaja.vue?vue&type=script&lang=js"
export * from "./modalCaja.vue?vue&type=script&lang=js"
import style0 from "./modalCaja.vue?vue&type=style&index=0&id=4c09ac63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c09ac63",
  null
  
)

export default component.exports